import config from '../config';
import { customFetch, authHeader, jsonHeader, handleResponse, commonRequestOptions } from '../helpers';

const endpointPath = 'network/networking-event'

export const networkingEventService = {
    getAll,
    create,
    update,
    remove,
};

function getAll(signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}

function create(item, signal) {
    const requestOptions = { method: 'POST', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(item) };
    return customFetch(`${config.api.url}/${endpointPath}`, requestOptions, signal).then(handleResponse);
}

function update(ref, item, signal) {
    const requestOptions = { method: 'PUT', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(item) };
    return customFetch(`${config.api.url}/${endpointPath}/${ref}`, requestOptions, signal).then(handleResponse);
}

function remove(ref, signal) {
    const requestOptions = { method: 'DELETE', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/${ref}`, requestOptions, signal).then(handleResponse);
}
